import { createContext, useContext, useState, useEffect } from "react";

const MenuContext = createContext();

export const useMenuContext = () => useContext(MenuContext);

export const MenuProvider = ({ children }) => {
    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        const fetchMenu = async () => {
            try {
                const response = await fetch(
                    "https://api.psicopatici.com/api/v1/menu-by-location?location=menu-totem"
                );
                const data = await response.json();
                if (data.success && Array.isArray(data.data)) {
                    setMenuItems(data.data);
                }
            } catch (error) {
                console.error("Errore nel caricamento del menu:", error);
            }
        };

        fetchMenu();
    }, []); // Carica solo una volta

    return (
        <MenuContext.Provider value={{ menuItems, setMenuItems }}>
            {children}
        </MenuContext.Provider>
    );
};
